type AiSectionHeadingProps = {
  title: string;
  subtitle?: string;
};

// Shared heading treatment for the AI Maintenance page's main sections (Account subscription,
// Token usage, User access) so the whole page reads as one consistent heading style.
export const AiSectionHeading = ({ title, subtitle }: AiSectionHeadingProps) => (
  <div>
    <p className="font-semibold text-lg py-2">{title}</p>
    {subtitle && <p className="text-sm text-muted-foreground mb-4">{subtitle}</p>}
  </div>
);
